<template>
  <div class="unifit-page">
    <div class="unifit-frame">
      <img
        class="unifit-bg"
        src="https://aipay.intelite.com.br/api/Arquivos/69b817a09a69c536c6239e65/download/1776883457292_BG.png"
        alt=""
      >

      <div class="unifit-content">
        <div class="unifit-top-info">
          <span class="unifit-day">{{ diaSemana }}</span>
          <span class="unifit-time">{{ horarioAtual }}</span>
        </div>

        <div class="unifit-actions">
          <span class="unifit-welcome">Bem-Vindo</span>
          <button
            class="unifit-btn"
            @click="abrirIframe('https://evo-totem.w12app.com.br/unifit/1/totem/imprimirTreinos?onlyTraining=true')"
          >
            <span class="unifit-btn-icon">
              <img
                src="https://aipay.intelite.com.br/api/Arquivos/69b817a09a69c536c6239e65/download/1776884223327_Camada_3.png"
                alt=""
              >
            </span>
            <span class="unifit-btn-text">IMPRIMA SEU TREINO</span>
          </button>

          <button
            class="unifit-btn"
            @click="abrirIframe('https://avalize.intelite.com.br/questionarios?q=69ceb581d30d7c9fba6881da')"
          >
            <span class="unifit-btn-icon">
              <img
                src="https://aipay.intelite.com.br/api/Arquivos/69b817a09a69c536c6239e65/download/1776884089386_Camada_4.png"
                alt=""
              >
            </span>
            <span class="unifit-btn-text">DÊ SEU FEEDBACK</span>
          </button>
        </div>

        <div class="unifit-logo">
          <img
            src="https://aipay.intelite.com.br/api/Arquivos/69b817a09a69c536c6239e65/download/1776883571839_Logo.png"
            alt="Unifit Academia"
          >
        </div>

        <div class="unifit-footer">
          <img
            src="https://aipay.intelite.com.br/api/Arquivos/69b817a09a69c536c6239e65/download/1776883621188_Assinatura.png"
            alt="feito por Intelite"
            class="unifit-assinatura"
          >
        </div>
      </div>
    </div>

    <v-dialog v-model="iframe.dialogo" persistent fullscreen scrollable>
      <v-card>
        <v-card-title style="padding: 0px;">
          <v-toolbar flat>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="iframe.dialogo = false">
                  <v-icon color="error" large>mdi-close-circle</v-icon>
                </v-btn>
              </template>
              <span>Fechar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="recarregarIframe">
                  <v-icon color="primary" large>mdi-reload</v-icon>
                </v-btn>
              </template>
              <span>Recarregar</span>
            </v-tooltip>
          </v-toolbar>
        </v-card-title>

        <v-card-text style="padding: 0px; margin: 0px;">
          <div
            v-if="iframe.carregamento"
            style="
              position: absolute;
              inset: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              background: rgba(255,255,255,0.7);
              z-index: 1;
            "
          >
            <v-progress-circular indeterminate color="primary" />
          </div>

          <iframe
            ref="iframe"
            :src="iframe.link"
            frameborder="0"
            width="100%"
            height="100%"
            style="margin: 0px;"
            @load="onLoad"
          ></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { mapState } from 'vuex'
  export default {
    components: {
      Loading
    },

    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),

    data: function () {
      return {
        isLoading: false,
        fullPage: true,
        empresa: [],
        diaSemana: '',
        horarioAtual: '',
        clockInterval: null,
        iframe: {
          dialogo: false,
          link: '',
          carregamento: false,
        }
      }
    },

    watch: {
      'iframe.dialogo'(val) {
        if (!val) {
          setTimeout(() => {
            this.iframe.link = ''
          }, 300);
        }
      },
    },

    mounted: function () {
      this.atualizarDataHora()
      this.clockInterval = setInterval(() => {
        this.atualizarDataHora()
      }, 1000)
    },

    beforeDestroy() {
      if (this.clockInterval) {
        clearInterval(this.clockInterval)
      }
    },

    methods: {
      atualizarDataHora() {
        const agora = new Date()
        const dia = new Intl.DateTimeFormat('pt-BR', { weekday: 'long' }).format(agora)
        this.diaSemana = dia.charAt(0).toUpperCase() + dia.slice(1)
        const dd = String(agora.getDate()).padStart(2, '0')
        const mes = String(agora.getMonth() + 1).padStart(2, '0')
        const hh = String(agora.getHours()).padStart(2, '0')
        const mm = String(agora.getMinutes()).padStart(2, '0')
        const ss = String(agora.getSeconds()).padStart(2, '0')
        this.horarioAtual = `${dd}/${mes} - ${hh}:${mm}:${ss}`
      },

      abrirIframe(url) {
        this.iframe.link = url

        setTimeout(() => {
          this.iframe.dialogo = true
        }, 100);
      },

      recarregarIframe() {
        this.iframe.carregamento = true
        this.$refs.iframe.src = this.$refs.iframe.src
      },

      onLoad() {
        this.iframe.carregamento = false
      },
    }
  }
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700;800;900&display=swap');

  .unifit-page {
    position: relative;
    width: 100%;
    min-height: 100vh;
    background: #1a1a1a;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .unifit-frame {
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: #1a1a1a;
  }

  .unifit-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    z-index: 0;
    pointer-events: none;
    user-select: none;
  }

  .unifit-content {
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-rows: auto 1fr auto auto;
    align-items: center;
    justify-items: center;
    padding: 4.5% 8% 4% 8%;
    box-sizing: border-box;
  }

  .unifit-top-info {
    grid-row: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.05;
    color: #fff;
    margin-top: 1%;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.65);
    font-family: 'Poppins', 'Montserrat', 'Segoe UI', 'Roboto', sans-serif;
  }

  .unifit-day {
    font-size: 56px;
    font-weight: 800;
    letter-spacing: 0.3px;
    text-transform: capitalize;
  }

  .unifit-time {
    font-size: 52px;
    font-weight: 800;
    margin-top: 8px;
    letter-spacing: 1.5px;
  }

  .unifit-actions {
    grid-row: 2;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 28px;
    padding-top: 18%;
  }

  .unifit-welcome {
    color: #fff;
    font-family: 'Poppins', 'Montserrat', 'Segoe UI', 'Roboto', sans-serif;
    font-weight: 800;
    font-size: 54px;
    line-height: 1;
    margin-bottom: 10px;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.6);
  }

  .unifit-btn + .unifit-btn {
    margin-top: 0;
  }

  .unifit-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 91%;
    background: #ff7a1a;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.58);
    outline: none;
    border-radius: 40px;
    padding: 4.3% 5.5%;
    cursor: pointer;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
    transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
    font-family: 'Poppins', 'Montserrat', 'Segoe UI', 'Roboto', sans-serif;
    font-weight: 800;
  }

  .unifit-btn:hover {
    background: #ff8a32;
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
  }

  .unifit-btn:active {
    transform: translateY(0);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.35);
  }

  .unifit-btn-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 76px;
    height: 76px;
    margin-right: 18px;
    flex-shrink: 0;
  }

  .unifit-btn-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  .unifit-btn-text {
    font-family: 'Poppins', 'Montserrat', 'Segoe UI', 'Roboto', sans-serif;
    font-size: 48px;
    font-weight: 800 !important;
    letter-spacing: 0.3px;
    line-height: 0.9;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.15);
  }

  .unifit-logo {
    grid-row: 3;
    align-self: center;
    width: 100%;
    text-align: center;
    transform: translateY(-40px);
    position: relative;
    z-index: 3;
  }

  .unifit-logo img {
    width: 100%;
    max-width: 74%;
    height: auto;
    display: block;
    margin: 0 auto;
  }

  .unifit-footer {
    grid-row: 4;
    width: 100%;
    text-align: center;
    margin-top: 4%;
  }

  .unifit-assinatura {
    width: 100%;
    max-width: 22%;
    height: auto;
    opacity: 0.95;
  }

  @media (min-width: 600px) {
    .unifit-welcome {
      font-size: 60px;
    }

    .unifit-day {
      font-size: 64px;
    }

    .unifit-time {
      font-size: 60px;
    }

    .unifit-btn-text {
      font-size: 52px;
    }
  }
</style>
